import meta from '../app_version.json';

export const APP_VERSION = meta.version;
export const APP_NAME = meta.appName;
export const COPYRIGHT_HOLDER = meta.copyrightHolder;
export const FIRST_RELEASE_DATE = meta.firstReleaseDate;
export const RELEASES = meta.releases || [];

export function getReleases() {
  return RELEASES;
}

export function getCopyrightYears() {
  const currentYear = new Date().getFullYear();
  if (currentYear > meta.copyrightYearStart) {
    return `${meta.copyrightYearStart}–${currentYear}`;
  }
  return String(meta.copyrightYearStart);
}

export function getCopyrightText() {
  return `© ${getCopyrightYears()} ${COPYRIGHT_HOLDER}`;
}

export function getVersionLabel() {
  return `v${APP_VERSION}`;
}

export function getFooterText() {
  return `${getCopyrightText()} · ${APP_NAME} ${getVersionLabel()}`;
}

export function getReleaseHint() {
  const [year, month, day] = FIRST_RELEASE_DATE.split('-');
  return `Релиз ${day}.${month}.${year}`;
}
